export default __webpack_public_path__ + "static/media/Bracers of the Savage Slaughter.86ab0a9d.jpg";